import {combineReducers} from '@reduxjs/toolkit';

import {mcpLimitLogReducer} from './connector-limits-tab/audit-log/mcp-limit-log.reducer';
import {reportsReducer} from './report-tab';
import {accountLicenseFeaturesSlice} from './services/account-license-features-slice';

export const licenseAndFeatures = combineReducers({
    license: accountLicenseFeaturesSlice.reducer,
    reports: reportsReducer,
    mcpLimitLog: mcpLimitLogReducer,
});
